import { render, staticRenderFns } from "./VerbTenses.vue?vue&type=template&id=98bec16a&lang=pug&"
import script from "./VerbTenses.vue?vue&type=script&lang=js&"
export * from "./VerbTenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports